import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const UserAgreement = ({ visible, onHide }) => {
    return (
        <Dialog
            header="Ç.Ü. YZ Akademi Kullanıcı Sözleşmesi"
            visible={visible}
            style={{width: '75vw', maxWidth: '900px'}}
            onHide={onHide}
            modal
        >
            <div style={{maxHeight: '75vh', overflowY: 'auto', fontSize: '0.9rem', lineHeight: 1.6, padding: '0 1rem'}}>
                <h5 style={{marginTop: 0}}>1. Amaç ve Kapsam</h5>
                <p>
                    Bu Kullanıcı Sözleşmesi, Çukurova Üniversitesi Bilimsel Araştırma Proje Birimi'nde <strong>FBA-2023-15236</strong> kodlu
                    "Yapay Zeka Temelli Bir Çevrimiçi Eğitim Sistemi Tasarım ve Geliştirmesi" başlıklı proje çıktısı yazılım olan
                    <strong> yzakademi.cu.edu.tr</strong> ("Platform") adresinde sunulan dijital eğitim, içerik, video ders ve yapay zekâ destekli
                    analiz hizmetlerinden yararlanan kullanıcıların ("Kullanıcı") hak ve yükümlülüklerini belirlemek amacıyla düzenlenmiştir.
                </p>
                <p>
                    Platformu ziyaret eden, kayıt olan veya herhangi bir şekilde kullanan her kullanıcı, bu sözleşmede belirtilen koşulları
                    okumuş, anlamış ve kabul etmiş sayılır.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>2. Hizmetin Niteliği</h5>
                <p>
                    YZ Akademi, kullanıcılarına uzaktan eğitim, dijital içerik paylaşımı, akademik analiz, yapay zekâ tabanlı geri bildirim
                    sistemleri ve kullanıcı etkileşimlerinin değerlendirilmesine yönelik araçlar sunar.
                </p>
                <p>
                    Platform, akademik amaçlarla veri analizi yapabilir. Bu analizler, kullanıcı deneyimini iyileştirmek, öğretim yöntemlerini
                    geliştirmek ve akademik araştırmalar yürütmek amacıyla gerçekleştirilebilir.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>3. Veri Toplama ve İşleme</h5>
                <p>Platform üzerinde kullanıcı etkileşimlerine ilişkin aşağıdaki veriler toplanabilir ve işlenebilir:</p>
                <ul style={{paddingLeft: '1.5rem'}}>
                    <li>İzlenen video derslerin süre, tarih ve izleme yoğunluğu bilgileri</li>
                    <li>Kullanıcının fare hareketleri, tıklama noktaları ve tarayıcı hareketleri</li>
                    <li>Platform üzerindeki sayfa gezinme geçmişi, oturum süresi ve geri bildirim verileri</li>
                    <li>Gönüllü olarak doldurulan anket ve değerlendirme formlarındaki bilgiler</li>
                </ul>
                <p>
                    Bu veriler, anonimleştirilerek akademik analiz, öğrenme davranışı modellemesi ve yapay zekâ algoritmalarının
                    geliştirilmesi için kullanılabilir. Kullanıcı, platformu kullanmakla bu veri işleme süreçlerine rıza göstermiş sayılır.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>4. Gizlilik ve Veri Güvenliği</h5>
                <p>
                    Toplanan tüm veriler, <strong>Kişisel Verilerin Korunması Kanunu (KVKK) No. 6698</strong> ve ilgili mevzuata uygun
                    olarak işlenir ve saklanır. Veriler üçüncü şahıslarla paylaşılmaz; yalnızca akademik araştırmalar ve sistem iyileştirme
                    süreçlerinde anonim ve istatistiksel biçimde kullanılabilir.
                </p>
                <p>
                    Kullanıcı, dilediği zaman kişisel verilerinin işlenmesine ilişkin bilgi talep edebilir veya silinmesini isteyebilir.
                    Bu talepler, platformun iletişim kanalları üzerinden alınır.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>5. Kullanıcı Yükümlülükleri</h5>
                <p>Kullanıcı, platformu yalnızca eğitim ve akademik amaçlarla kullanmayı kabul eder. Aşağıdaki eylemler kesinlikle yasaktır:</p>
                <ul style={{paddingLeft: '1.5rem'}}>
                    <li>Platformda sunulan video dersleri, görselleri veya içerikleri indirmek, kaydetmek veya yeniden paylaşmak</li>
                    <li>Platformun teknik altyapısına zarar verebilecek veya işleyişi bozabilecek eylemlerde bulunmak</li>
                    <li>Başka kullanıcıların gizliliğini ihlal etmek veya kimlik bilgilerini kullanmak</li>
                    <li>Platformun analiz sistemlerini manipüle edecek yazılım veya araçlardan yararlanmak</li>
                </ul>
                <p>
                    Yukarıdaki maddelerin ihlali durumunda, kullanıcı hesabı süresiz olarak askıya alınabilir ve gerekli yasal işlemler başlatılabilir.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>6. Yapay Zekâ Tabanlı Analiz ve Akademik Kullanım</h5>
                <p>Platform, kullanıcı davranışlarını anlamak ve eğitim verimliliğini artırmak amacıyla yapay zekâ algoritmaları kullanır. Bu analizler:</p>
                <ul style={{paddingLeft: '1.5rem'}}>
                    <li>Kullanıcıların öğrenme eğilimlerini belirlemek</li>
                    <li>İçeriklerin etkililiğini ölçmek</li>
                    <li>Akademik araştırmalarda istatistiksel veri sağlamak</li>
                </ul>
                <p>amaçlarıyla yapılır. Yapay zekâ sistemleri, kişisel kimlik bilgilerini doğrudan tanımlayacak biçimde veri üretmez.</p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>7. Fikri Mülkiyet Hakları</h5>
                <p>
                    YZ Akademi üzerinde yer alan tüm içerikler (videolar, metinler, grafikler, yazılımlar, veritabanları ve tasarımlar)
                    proje ekibine, Çukurova Üniversitesi'ne, içerik üreticilere veya lisans veren üçüncü taraflara aittir.
                    Bu içerikler izinsiz kopyalanamaz, çoğaltılamaz, yayınlanamaz veya ticari amaçla kullanılamaz.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>8. Sözleşmenin Değiştirilmesi</h5>
                <p>
                    Proje ekibi, bu sözleşmeyi dilediği zaman güncelleme hakkını saklı tutar. Güncellenen metinler,
                    <strong> yzakademi.cu.edu.tr</strong> adresinde yayımlandığı anda yürürlüğe girer.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>9. Sorumluluğun Sınırlandırılması</h5>
                <p>
                    Platform, kullanıcıların kendi internet bağlantısı, donanımı veya üçüncü taraf hizmetlerinden kaynaklanan sorunlardan
                    sorumlu değildir. Yapay zekâ algoritmalarının analiz sonuçları yalnızca akademik ve istatistiksel amaçlı olup,
                    kesin bir değerlendirme veya otomatik karar sistemi olarak kullanılmaz.
                </p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>10. Uyuşmazlıkların Çözümü</h5>
                <p>Bu sözleşmeden doğabilecek uyuşmazlıkların çözümünde Adana Mahkemeleri ve İcra Daireleri yetkilidir.</p>

                <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />

                <h5 style={{marginTop: '1rem'}}>11. İletişim</h5>
                <p>Her türlü soru, öneri veya veri işleme talebi için:</p>
                <p style={{paddingLeft: '1rem'}}>
                    <strong>E-posta:</strong> ykuvvetli@cu.edu.tr<br/>
                    <strong>Adres:</strong> Çukurova Üniversitesi Endüstri Mühendisliği Bölümü, Balcalı Kampüsü, Sarıçam / ADANA
                </p>

                <p style={{marginTop: '1.5rem', fontWeight: 'bold'}}>
                    Yürürlük Başlangıç Tarihi: 31.10.2025
                </p>
                <p style={{fontStyle: 'italic', marginBottom: 0}}>
                    Kullanıcı, platformu kullanmaya başladığı andan itibaren yukarıdaki koşulları okumuş, anlamış ve kabul etmiş sayılır.
                </p>
            </div>
            <div className="flex justify-content-end mt-3">
                <Button label="Kapat" size="small" onClick={onHide} text/>
            </div>
        </Dialog>
    );
};

export default UserAgreement;
